// The final per-piece approval's routes (server: dashboard/piecePublish.js).
const BASE = 'photo-pipeline/publish';

export const getPublishPieces = fetchResource => fetchResource({ method: 'GET', resource: `${BASE}/pieces`, loadingKey: 'publishList' });
// Quiet: the preview explains its own failures, and a live piece's 409 is an answer.
export const getPiecePreview = (fetchResource, sku) =>
    fetchResource({ method: 'GET', resource: `${BASE}/${sku}/preview`, loadingKey: 'preview', quiet: true });
// `version` is the preview's: the server refuses (409, with the current one)
// when the shots changed since it was shown. Quiet: the preview shows the outcome.
export const approveAndPublish = (fetchResource, sku, version) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/approve`, body: { version }, quiet: true });
// Every approved shot of the piece back to review. Quiet: the preview shows the outcome.
export const sendBackPiece = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/send-back`, quiet: true });
// "Reopen piece" (photoPipeline/reopen.js): a live piece back to review, its
// live photos as "Live version"s. Nothing on the site changes until the piece
// is approved again. Quiet: the dialog words each refusal.
export const reopenPiece = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/reopen`, quiet: true });
// "Reopen piece" by a handle or product link: `{sku, title, handle}`, or a
// refusal with a `reason`. Quiet: the dialog words each refusal.
export const resolvePiece = (fetchResource, q) =>
    fetchResource({ method: 'GET', resource: `${BASE}/resolve?q=${encodeURIComponent(q)}`, quiet: true });
// "Cancel reopen": every shot back exactly as published. Quiet: the notice
// shows the server's reason when it refuses.
export const cancelReopen = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/cancel-reopen`, quiet: true });
// The upload page's "Do you want to reshoot it?" → Yes: the same reopen in
// reshoot mode, at the clerk's tier. Quiet: the dialog shows a refusal.
export const reshootPiece = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `photo-pipeline/reshoot/${sku}`, quiet: true });
